<template>
    <div class="flex items-center">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1501 562"
            fill="none"
            class="h-7 w-auto text-cta-active"
            role="img"
            aria-label="Litta"
        >
            <path
                d="M377.292 445.849V561.905H127.86C57.7753 561.905 0.441895 504.356 0.441895 434.055V0.334595H126.717V422.539C126.717 435.414 137.122 445.849 149.935 445.849H377.292Z"
                fill="currentColor"
            />
            <path
                d="M471.15 137.416C509.063 137.416 539.752 105.863 539.752 68.5665C539.752 31.2705 508.261 0.550659 471.15 0.550659C434.039 0.550659 403.381 31.3322 403.381 68.5665C403.381 105.801 433.236 137.416 471.15 137.416Z"
                fill="currentColor"
            />
            <path
                d="M1092.59 299.567V184.623H1014.32V-0.00500488H887.643V184.623H769.024V-0.00500488H642.347V184.437H408.136L408.198 561.905H534.874V298.425H642.378V356.222C642.378 469.561 734.353 561.875 847.29 561.875V446.93C803.727 446.93 769.024 412.104 769.024 356.252V299.567H887.643V356.191C887.643 469.53 979.617 561.844 1092.56 561.844V446.899C1048.99 446.899 1014.29 412.073 1014.29 356.222V299.536H1092.56L1092.59 299.567Z"
                fill="currentColor"
            />
            <path
                d="M1311.82 184.067C1207.87 184.067 1123.18 268.323 1123.18 373.388C1123.18 478.452 1207.87 561.967 1311.82 561.967H1500.4V373.388C1500.4 268.323 1415.75 184.067 1311.82 184.067ZM1311.79 447.331C1270.85 447.331 1237.69 414.049 1237.69 372.986C1237.69 331.924 1270.85 298.641 1311.79 298.641C1352.73 298.641 1385.89 331.924 1385.89 372.986C1385.89 414.049 1352.73 447.331 1311.79 447.331Z"
                fill="currentColor"
            />
            <path
                d="M1464.03 206.482V187.432H1457.55V184.376H1474.25V187.432H1467.77V206.482H1464.03Z"
                fill="currentColor"
            />
            <path
                d="M1477.4 206.482V184.376H1481.88L1488.95 198.64L1495.93 184.376H1500.43V206.482H1496.67V190.859L1490.43 203.363H1487.47L1481.2 190.89V206.482H1477.43H1477.4Z"
                fill="currentColor"
            />
        </svg>
    </div>
</template>
